<template>
  <CFooter>
    <div class="ms-auto">
      <span class="ms-1">&copy; {{ new Date().getFullYear() }} Powered by</span>
      <a v-if="branding.poweredUrl" :href="branding.poweredUrl" target="_blank" rel="noopener" class="ms-1">{{ branding.poweredBy }}</a>
      <strong v-else class="ms-1">{{ branding.poweredBy }}</strong>
    </div>
  </CFooter>
</template>

<script>
import { branding } from '@/utils/branding'

export default {
  name: 'AppFooter',
  data() {
    return { branding }
  },
}
</script>
